export interface RenderToImageOptions {
  /**
   * Font family name.
   * @default system default
   */
  fontFamily?: string;
  /**
   * Size of the font.
   * @default 24
   */
  size?: number;
  /**
   * Font color
   * @default 'black'
   */
  color?: string;
}
